import RestorePasswordForm from './RestorePasswordForm.jsx';

export {RestorePasswordForm};



// WEBPACK FOOTER //
// ./components/restore-password/index.js